import { css } from '@emotion/react';
import { useEffect } from 'react';
import Button from '../../components/Button';
import useMessageService from '../../services/i18n/useMessageService';
import PageContainer from '../../components/PageContainer';
import { useAppMetadataContext } from '../../components/AppMetadataContextWrapper';
import getTargetAttribute from '../../services/getTargetAttribute';
import RegisterUtils from './registerUtils';

const RegisterConfirmation = ({ onConfirm }) => {
    const [
        [
            pageTitle = 'Congratulations',
            confirmationDescription = 'You now have a VeevaID and you will be redirected to {0} in 10 seconds.',
            buttonLabel = 'Go to {0}',
            veevaIdName = 'VeevaID',
        ],
    ] = useMessageService([
        'register.confirm_title',
        'register.confirm_description',
        'register.confirm_button_label',
        'general.veevaid',
    ]);
    const { appMetadata } = useAppMetadataContext();

    useEffect(() => {
        const timeout = setTimeout(() => {
            onConfirm?.();
        }, RegisterUtils.getConfirmationTimeoutDuration());
        return () => {
            clearTimeout(timeout);
        };
    }, [onConfirm]);

    return (
        <PageContainer title={pageTitle}>
            <div
                css={css`
                    text-align: center;
                    margin-bottom: 3.33rem;
                `}
            >
                {confirmationDescription?.replace('{0}', appMetadata?.app_name || veevaIdName)}
            </div>
            <Button
                type="button"
                onClick={onConfirm}
                data-target={getTargetAttribute('app-button')}
            >
                {buttonLabel?.replace('{0}', appMetadata?.app_name || veevaIdName)}
            </Button>
        </PageContainer>
    );
};

export default RegisterConfirmation;
